import { Scale, ShieldCheck, Lock, MessagesSquare, UserCheck } from "lucide-react";
import { Reveal } from "./Reveal";

const PILLARS = [
    {
        icon: Scale,
        title: "Professionalism",
        desc: "Upholding high standards of legal conduct and meticulous preparation in every matter.",
    },
    {
        icon: ShieldCheck,
        title: "Integrity",
        desc: "Honest, ethical guidance and transparent counsel grounded in trust.",
    },
    {
        icon: Lock,
        title: "Confidentiality",
        desc: "Absolute safeguarding of client information and sensitive legal discussions.",
    },
    {
        icon: MessagesSquare,
        title: "Clear Communication",
        desc: "Plain-spoken legal analysis without opaque jargon, keeping clients informed at every stage.",
    },
    {
        icon: UserCheck,
        title: "Personalized Legal Service",
        desc: "Direct engagement with counsel, tailoring legal strategies to individual circumstances.",
    },
];

const About = () => (
    <section id="about" className="bg-white py-24 lg:py-32">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
            <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
                <Reveal>
                    <div className="relative">
                        <div className="absolute -top-4 -left-4 w-full h-full border border-[#B89047]/40" aria-hidden="true" />
                        <img
                            src="https://images.pexels.com/photos/8731037/pexels-photo-8731037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                            alt="Legal jurisprudence and ethics at Dan Rosengarten Law Firm"
                            className="relative w-full aspect-[4/3] object-cover"
                            loading="lazy"
                        />
                    </div>
                </Reveal>

                <div>
                    <Reveal>
                        <p className="font-mono-label text-[11px] tracking-[0.3em] uppercase text-[#8E6C2D] mb-5">
                            About the Firm
                        </p>
                        <h2 className="font-serif-display text-3xl lg:text-4xl font-medium tracking-tight text-[#0B192C] leading-[1.2]">
                            A practice built on trust, diligence, and personal attention
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="mt-6 text-base text-slate-600 leading-relaxed">
                            Dan Rosengarten Law Firm is a South African legal practice committed to
                            providing considered, professional legal representation. The firm works
                            closely with every client — taking the time to understand the
                            circumstances behind each matter before offering clear, practical guidance.
                        </p>
                        <p className="mt-4 text-base text-slate-600 leading-relaxed">
                            Every instruction, whether large or small, is approached with the same
                            care: rigorous preparation, straightforward communication, and respect
                            for the confidence clients place in the firm.
                        </p>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <div className="gold-rule mt-10" />
                    </Reveal>
                </div>
            </div>

            <div className="mt-16 lg:mt-20 grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-slate-200/80 border border-slate-200/80">
                {PILLARS.map((p, i) => (
                    <Reveal key={p.title} delay={i * 0.06} className="bg-white">
                        <div
                            data-testid={`about-pillar-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
                            className="h-full p-7 group hover:bg-[#FAF6EE] transition-colors duration-300"
                        >
                            <p.icon size={22} strokeWidth={1.5} className="text-[#B89047]" aria-hidden="true" />
                            <h3 className="mt-4 font-serif-display text-lg font-medium text-[#0B192C]">
                                {p.title}
                            </h3>
                            <p className="mt-2 text-sm text-slate-500 leading-relaxed">{p.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default About;
